// removed by extract-text-webpack-plugin
module.exports = {"buttonLink":"Button-example__buttonLink__2gB0R","buttonLinkPrimary":"Button-example__buttonLinkPrimary__1crqg","buttonLinkSecondary":"Button-example__buttonLinkSecondary__3YeNe","customButton":"Button-example__customButton__vvC1O","customIcon":"Button-example__customIcon__1StrU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.example.css
// module id = 2403
// module chunks = 0